import { orchestrator, mutatorAction } from 'satcheljs';
import type { ProjectId, AssetId } from 'owa-timestream-types';
import {
    getLastKnownBounds,
    removeBucketChild,
    snapToGrid,
    updateAssetParent,
    getAsset,
} from 'owa-timestream-store';
import { removeAssetFromBucket } from 'owa-timestream-asset-sdk-bucket';
import { getAssetDescriptor } from 'owa-timestream-asset-sdk';
import getNextAvailableAssetSpace from '../../util/getNextAvailableAssetSpace';

orchestrator(removeAssetFromBucket, ({ projectId, assetId, parentAssetId }) => {
    const assetDefaultPadding = 20;
    const oldAssetBounds = getLastKnownBounds(projectId, assetId);
    const parentAssetBounds = getLastKnownBounds(projectId, parentAssetId);
    const asset = getAsset(projectId, assetId);
    const assetDescriptor = getAssetDescriptor(asset.type);
    const nextAvailableSpace = assetDescriptor
        ? getNextAvailableAssetSpace(assetDescriptor)
        : undefined;

    if (nextAvailableSpace && parentAssetBounds && oldAssetBounds) {
        const newPosX = snapToGrid(nextAvailableSpace.x + assetDefaultPadding);
        const newPosY = snapToGrid(nextAvailableSpace.y + assetDefaultPadding);

        setAssetPosition(projectId, assetId, newPosX, newPosY);
        removeBucketChild(projectId, assetId, false /* movedIntoBucket */);
        updateAssetParent(projectId, assetId, null, undefined, false, newPosX, newPosY);
    }
});

const setAssetPosition = mutatorAction(
    'setAssetPosition',
    (projectId: ProjectId, assetId: AssetId, x: number, y: number) => {
        const asset = getAsset(projectId, assetId);
        asset.bounds.x = x;
        asset.bounds.y = y;
    }
);
